var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClassroom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_214",
    x: 0,
    y: 0,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.51
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2389",
    "data-name": "Group 2389",
    transform: "translate(2366.5 -2482.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(-2364 2485)",
    fill: "#dc2626"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2366.5, 2482.5)",
    filter: "url(#Ellipse_214)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_214-2",
    "data-name": "Ellipse 214",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(7.5 7.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2388",
    "data-name": "Group 2388",
    transform: "translate(-6 -64)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1987",
    "data-name": "Rectangle 1987",
    width: 34,
    height: 34,
    transform: "translate(-2340 2567)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2387",
    "data-name": "Group 2387",
    transform: "translate(3.42 62.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1985",
    "data-name": "Rectangle 1985",
    transform: "translate(-2340.42 2511.602)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 21,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 20,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1986",
    "data-name": "Rectangle 1986",
    width: 28,
    height: 6,
    rx: 1,
    transform: "translate(-2340.42 2511.602)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroom);
export default __webpack_public_path__ + "static/media/classroom.76aee6a518690141ed9d22ab83dcf081.svg";
export { ForwardRef as ReactComponent };